import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/users'
import Component from 'components/Users'

export default createListViewContainer({ actions, selectors: selectors.users })(Component)
